import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import { IRet } from '../types/FmsTypes'
import {
    CLIENT_APP_CODE,
    INTERNAL_SERVER_ERROR_CODE,
    getToken,
    getCiRequestUrl,
    DEFAULT_REQUEST_TIMEOUT,
    INTERNAL_SERVER_LOGON_FAILURE_CODE,
} from './constants'

import { message } from 'antd'
import storage from 'good-storage'
import moment from 'moment'

type errData = {
    url: string
    code: string | number
    time: string
}

class CiHttpRequest {
    private inst: AxiosInstance
    private url: string = ''

    constructor(config: AxiosRequestConfig = {}) {
        let defaultConfig = {
            baseURL: getCiRequestUrl(),
            timeout: DEFAULT_REQUEST_TIMEOUT,
            headers: { CAC: CLIENT_APP_CODE },
        }
        this.inst = axios.create({ ...defaultConfig, ...config })
        this.interceptRequest()
        this.interceptResponse()
    }

    private interceptRequest() {
        this.inst.interceptors.request.use(
            (config) => {
                this.url = config.url as string
                config.headers.Authorization = getToken()
                return config
            },
            (error) => Promise.reject(error)
        )
    }

    private interceptResponse() {
        this.inst.interceptors.response.use(
            (response) => response,
            (error) => {
                let res = error.response as AxiosResponse
                // if (res && res.status && res.status === INTERNAL_SERVER_ERROR_CODE) {
                //     //处理自定义业务异常
                //     //....
                //     let retData = res.data as IRet<any>
                //     message.error(`${retData.retMsg}`)
                // } else if (res && res.status && res.status === INTERNAL_SERVER_LOGON_FAILURE_CODE) {
                //     //处理自定义业务异常
                //     //....
                //     let retData = res.data as IRet<any>
                //     message.error(`${retData.retMsg} 请重新登录`)
                // } else {
                //     message.error(`请求超时`)
                // }
                const url = this.url
                let addErr: errData = { url, time: moment().format('YYYY-MM-DD HH:mm:ss'), code: '' }
                if (res) {
                    let retData = res.data as IRet<any>
                    addErr.code = res.status
                    message.error(`code:${res.status} msg:${retData.retMsg} retData:${retData.retData}`)
                } else {
                    message.error('服务器响应超时，请尝试重新请求')
                    addErr.code = 'timeout'
                }
                let requestErrData: errData[] = storage.get('requestErrData') || []
                requestErrData.unshift(addErr)
                storage.set('requestErrData', requestErrData.slice(0, 100))
                return Promise.reject(error)
            }
        )
    }

    private responseTypeCheck(res: AxiosResponse) {
        const resType = res.headers['content-type']
        if (resType !== 'application/json') {
            console.log('只支持json返回数据!')
            //.....
        }
    }

    async request<T>(config: AxiosRequestConfig) {
        let ret = await this.inst.request<IRet<T>>(config)
        this.responseTypeCheck(ret)
        return ret.data
    }

    async post<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let postData = data ?? {}
        if (!postData['sourceApp']) {
            postData['sourceApp'] = CLIENT_APP_CODE
        }
        let ret = await this.inst.post<IRet<T>>(url, postData, config)
        this.responseTypeCheck(ret)
        return ret.data
    }

    async postWithTimeout<T>(url: string, data?: any, timeout?: number, config?: AxiosRequestConfig) {
        let postData = data ?? {}
        if (!postData['sourceApp']) {
            postData['sourceApp'] = CLIENT_APP_CODE
        }
        const conf = { ...config, timeout: timeout };
        let ret = await this.inst.post<IRet<T>>(url, postData, conf)
        this.responseTypeCheck(ret)
        return ret.data
    }


    async postFile<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.post<IRet<T>>(url, data, { ...config, responseType: 'blob' })
        return ret
    }

    async postFileWithTimeout<T>(url: string, data?: any, timeout?: number, config?: AxiosRequestConfig) {
        const conf = { ...config, timeout: timeout };
        let ret = await this.inst.post<IRet<T>>(url, data, { ...conf, responseType: 'blob' })
        return ret
    }

    async post1<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.post<IRet<T>>(url, data ?? {}, config)
        this.responseTypeCheck(ret)
        return ret.data
    }

    async get<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.get<IRet<T>>(url, config)
        this.responseTypeCheck(ret)
        return ret.data
    }

    async put<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.put<IRet<T>>(url, data, config)
        return ret.data
    }

    async delete<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.delete<IRet<T>>(url, config)
        return ret.data
    }

    async head<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.head<IRet<T>>(url, config)
        return ret.data
    }

    async options<T>(url: string, config?: AxiosRequestConfig) {
        let ret = await this.inst.options<IRet<T>>(url, config)
        return ret.data
    }

    async patch<T>(url: string, data?: any, config?: AxiosRequestConfig) {
        let ret = await this.inst.patch<IRet<T>>(url, data, config)
        return ret.data
    }
}

export const ciHttpRequest = new CiHttpRequest()
